import React from 'react';

import { Card, CardBody, CardTitle, Container, Row, Col } from 'reactstrap';
import { get, toNumber } from 'lodash-es';

import Spin from 'antd/lib/spin';
import 'antd/lib/spin/style/index.css';
import { LoadingOutlined } from '@ant-design/icons';

import { createUseStyles } from 'react-jss';
import { useCustomerSingleMetrics } from '../../utils/queries/customerQueries';
import { humanizeDurationnHoursMinutes } from '../../utils/misc';

const useStyles = createUseStyles({
  header: {
    paddingTop: (props) => props.paddingTop || '6rem',
    paddingBottom: (props) => props.paddingBottom || '8rem',
    marginTop: (props) => props.marginTop || '0.25rem',
  },
});

const CustomerSingleMetricsHeader = ({ ...props }) => {
  const classes = useStyles(props);

  const { data, isLoading, error } = useCustomerSingleMetrics();

  function displayDuration() {
    const durationObj = humanizeDurationnHoursMinutes(
      (toNumber(get(data, 'TIME_SPENT', 0)) / 60).toFixed(2),
    );
    if (durationObj.hours === 0) {
      return {
        minutes: durationObj.minutes,
        hours: 0,
      };
    } else {
      return {
        minutes: durationObj.minutes,
        hours: durationObj.hours,
      };
    }
  }

  return (
    <>
      <div className={classes.header} /* className="pb-8 pt-md-7 mt-1" */>
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row style={{ justifyContent: 'flex-start' }}>
              <Col lg="6" xl="3">
                <Card
                  className="card-stats mb-4 mb-xl-0"
                  style={{
                    border: '1px solid #dedee1',
                    borderRadius: '10px',
                  }}
                >
                  <CardBody>
                    <Row>
                      <div
                        className="col"
                        style={{
                          justifyContent: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted text-center mb-0"
                        >
                          Charging Sessions
                        </CardTitle>
                        <span
                          className="h1 font-weight-bold text-center mb-0"
                          style={{ fontSize: '30px' }}
                        >
                          {isLoading ? (
                            <Spin
                              spinning={isLoading}
                              size="large"
                              className={classes.antSpinner}
                              indicator={
                                <LoadingOutlined
                                  style={{ color: '#2675b8', fontSize: 17 }}
                                />
                              }
                            />
                          ) : error ? (
                            'Error occured'
                          ) : (
                            get(data, 'TOTAL_SESSION', 0) || 0
                          )}
                        </span>
                      </div>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> 3.48%
                      </span>{' '}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card
                  className="card-stats mb-4 mb-xl-0"
                  style={{
                    border: '1px solid #dedee1',
                    borderRadius: '10px',
                  }}
                >
                  <CardBody>
                    <Row>
                      <div
                        className="col"
                        style={{
                          justifyContent: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted text-center mb-0"
                        >
                          Charging Duration
                        </CardTitle>
                        <span
                          className="h1 font-weight-bold text-center mb-0"
                          style={{ fontSize: '30px' }}
                        >
                          {isLoading ? (
                            <Spin
                              spinning={isLoading}
                              size="large"
                              className={classes.antSpinner}
                              indicator={
                                <LoadingOutlined
                                  style={{ color: '#2675b8', fontSize: 17 }}
                                />
                              }
                            />
                          ) : error ? (
                            'Error occured'
                          ) : displayDuration().hours === 0 ? (
                            <>
                              {displayDuration().minutes}{' '}
                              <span style={{ fontSize: '12px' }}>Minutes</span>
                            </>
                          ) : (
                            <>
                              {displayDuration().hours}{' '}
                              <span style={{ fontSize: '12px' }}>Hours</span>{' '}
                              {displayDuration().minutes}{' '}
                              <span style={{ fontSize: '12px' }}>Minutes</span>
                            </>
                          )}
                        </span>
                      </div>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> 3.48%
                      </span>{' '}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card
                  className="card-stats mb-4 mb-xl-0"
                  style={{
                    border: '1px solid #dedee1',
                    borderRadius: '10px',
                  }}
                >
                  <CardBody>
                    <Row>
                      <div
                        className="col"
                        style={{
                          justifyContent: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted text-center mb-0"
                        >
                          Energy Purchased
                        </CardTitle>
                        <span
                          className="h1 font-weight-bold text-center mb-0"
                          style={{ fontSize: '30px' }}
                        >
                          {isLoading ? (
                            <Spin
                              spinning={isLoading}
                              size="large"
                              className={classes.antSpinner}
                              indicator={
                                <LoadingOutlined
                                  style={{ color: '#2675b8', fontSize: 17 }}
                                />
                              }
                            />
                          ) : error ? (
                            'Error occured'
                          ) : (
                            toNumber(get(data, 'KWH_CONSUMED', 0)).toFixed(2) ||
                            0
                          )}{' '}
                          <span style={{ fontSize: '12px' }}>kWh</span>
                        </span>
                      </div>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-danger mr-2">
                        <i className="fas fa-arrow-down" /> 3.48%
                      </span>{' '}
                      <span className="text-nowrap">Since last week</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card
                  className="card-stats mb-4 mb-xl-0"
                  style={{
                    border: '1px solid #dedee1',
                    borderRadius: '10px',
                  }}
                >
                  <CardBody>
                    <Row>
                      <div
                        className="col"
                        style={{
                          justifyContent: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted text-center mb-0"
                        >
                          Amount Spent
                        </CardTitle>
                        <span
                          className="h1 font-weight-bold text-center mb-0"
                          style={{ fontSize: '30px' }}
                        >
                          <span style={{ fontSize: '18px' }}>₹</span>{' '}
                          {isLoading ? (
                            <Spin
                              spinning={isLoading}
                              size="large"
                              className={classes.antSpinner}
                              indicator={
                                <LoadingOutlined
                                  style={{ color: '#2675b8', fontSize: 17 }}
                                />
                              }
                            />
                          ) : error ? (
                            'Error occured'
                          ) : (
                            toNumber(
                              get(data, 'AMOUNT_SPENT', 0) / 100,
                            ).toFixed(2) || 0
                          )}
                        </span>
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default CustomerSingleMetricsHeader;
